// v-permission指令
import type { Directive } from 'vue'

const permissionMatrix: Record<string, Record<string, boolean>> = {
  OWNER: {
    child_add: true,
    add: true,
    delete: true,
    edit: true,
    view: true,
    transfer: true,
  },
  ADMIN: {
    child_add: true,
    add: true,
    delete: false, // 不能操作Owner成员，业务层处理
    edit: true, // 不能操作Owner成员，业务层处理
    view: true,
    transfer: false,
  },
  EDITOR: {
    child_add: true,
    add: false,
    delete: false,
    edit: true,
    view: true,
    transfer: false,
  },
  VIEWER: {
    child_add: false,
    add: false,
    delete: false,
    edit: false,
    view: true,
    transfer: false,
  },
}

// 校验权限函数
export function checkPermission(role: string, action: string): boolean {
  const matrix = permissionMatrix[role]
  if (!matrix)
    return false
  return !!matrix[action]
}

export const permissionDirective: Directive = {
  mounted(el, binding) {
    let actionList: string[] = []
    const [role, actions] = binding.value
    // 优先用修饰符
    const modifierAction = Object.keys(binding.modifiers)[0]
    if (modifierAction) {
      actionList = [modifierAction]
    }
    else if (Array.isArray(actions)) {
      actionList = actions
    }
    else if (typeof actions === 'string') {
      actionList = [actions]
    }
    else {
      actionList = ['view']
    }
    const has = actionList.some(action => checkPermission(role, action))
    if (!has) {
      el.style.display = 'none'
    }
  },
  updated(el, binding) {
    let actionList: string[] = []
    const [role, actions] = binding.value
    const modifierAction = Object.keys(binding.modifiers)[0]
    if (modifierAction) {
      actionList = [modifierAction]
    }
    else if (Array.isArray(actions)) {
      actionList = actions
    }
    else if (typeof actions === 'string') {
      actionList = [actions]
    }
    else {
      actionList = ['view']
    }
    const has = actionList.some(action => checkPermission(role, action))
    if (!has) {
      el.style.display = 'none'
    }
    else {
      el.style.display = ''
    }
  },
}

// 多操作用法示例：
// <button v-permission="['ADMIN', ['add', 'delete']]">增删</button>
// <button v-permission.add="['OWNER']">新增</button>
// <button v-permission="['OWNER', 'add']">新增</button>

// main.ts中全局注册：
// import { permissionDirective } from '@/utils/permission';
// app.directive('permission', permissionDirective);

/**
 * 通用权限判断方法
 * @param role 角色（如 'Admin'）
 * @param action 操作类型（如 'add' | 'delete' | 'edit' | 'view' | 'transfer'）
 * @returns 是否有权限
 */
export function hasPermission(role: string, action: string): boolean {
  return checkPermission(role, action)
}

// 用法示例：
// if (hasPermission('Admin', 'delete')) {
//   // 执行删除操作
// }
